import { render, staticRenderFns } from "./1585_检查字符串是否可以通过排序子字符串得到另一个字符串.md?vue&type=template&id=310c0417&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports